import React from 'react';
import {Link} from "react-router-dom";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';

const StatusDeclined = ({invitation, children}) => {

    if (invitation.rsvp_status !== 'declined') {
        return <></>;
    }

    return (
        <>
            {children}
            <hr />
            <div className="settings__item">
                <div>
                    <label><TextTranslate name="word-rsvp-status" fallback="RSVP Status"/></label>
                    <p className="font-weight-500"><TextTranslate name="word-invite-declined" fallback="Invite declined" /></p>
                </div>
                <div className="text-right">
                    <Link to="/contact" className="link text-primary"><TextTranslate name="word-contact-us" fallback="Contact Us"/></Link>
                </div>
            </div>
            <hr />
        </>
    );
}


export default StatusDeclined;
